import { ReactNode } from 'react';
import { replayAssetUrl } from 'lib/utils/imageUtils';
import { VIDEO_QUALITY } from 'lib/constants/replay';

interface Props {
  slideKey: string;
  active?: boolean;
  content: (animate: boolean) => ReactNode;
}

export const AnimatedBackground = ({
  slideKey,
  active,
  content,
}: Props) => {
  const getAnimatedBackground = (sl: string) => (
    <video
      className="z-0"
      src={replayAssetUrl(`Slide-${sl}-Loop.mp4?tr=q-${VIDEO_QUALITY}`)}
      autoPlay
      loop
      muted
      playsInline
    />
  );

  return (
    <div className="relative h-full w-full pointer-events-none">
      {getAnimatedBackground(slideKey)}
      {active && content(true)}
    </div>
  );
};
